import { Route, Routes } from "react-router-dom";
import { WisdomAcademyHome } from "./Views/WisdomAcademyHome/WisdomAcademyHome";
import { WisdomAcademyCourseDetails } from "./Views/WisdomAcademyCourseDetails/WisdomAcademyCourseDetails";

export const WisdomAcademy = () => {
  return (
    <Routes>
      <Route index element={<WisdomAcademyHome />} />
      <Route path="course/:courseId" element={<WisdomAcademyCourseDetails />} />
    </Routes>
  );
};
